// The county a collection-site save should send, or undefined to send none.
//
// The server looks a site's county up from its GPS point and keeps it current
// as the site moves. Sending a county pins it as typed by hand, so only send one
// when the user actually changed the field: the same value as before means
// "leave it", an emptied field means "look it up again".
export const countyForSave = (county, initialCounty) => {
  const next = (county ?? "").trim();
  const before = (initialCounty ?? "").trim();
  if (next === before) return undefined;
  return next;
};

// Where the shown county came from, for the hint under the field.
export const countySourceHint = (countySource) =>
  ({
    geocoded: "Looked up from the GPS location.",
    address: "Taken from the chosen address.",
    manual: "Entered by hand. Clear it to look it up from the GPS location again.",
  })[countySource] ?? "Looked up from the GPS location when the site is saved.";
